import { subscriptionExchange } from 'urql'
import { createPusherObserver } from './pusher/observer'

export const subscription = subscriptionExchange({
  forwardSubscription: (request, operation) => {
    return createPusherObserver(request, operation)
  },
})
